import styled from '@emotion/styled';

import { FastShippingNoticeBanner } from '@domains/pdp-common';

interface FastShippingBannerProps {
  noticeBanner: FastShippingNoticeBanner;
  handleClickBanner: () => void;
}

export const FastShippingBanner: React.FC<React.PropsWithChildren<FastShippingBannerProps>> = ({ noticeBanner, handleClickBanner }) => {
  return <Banner src={noticeBanner.image_url} onClick={handleClickBanner} />;
};

const Banner = styled.img`
  max-width: 720px;
  width: 100%;
  height: 44px;
  object-fit: cover;
`;
